import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, formValueSelector } from 'redux-form'
import PropTypes from 'prop-types'
import { isFetching } from 'utils/redux/fetching'
import { fetchSettings, updateSettings } from 'redux/actions/actions'
import ViewStatus from '../components/ViewStatus'
import Loader from 'components/Loader'

class SettingsStatus extends React.Component {

	componentWillMount() {
		const { dispatch } = this.props
		dispatch(fetchSettings())
	}

	render () {
		if (this.props.isFetching) return <Loader />

		return <ViewStatus {...this.props} />
	}
}

const mapDispatchToProps = dispatch => {
	return {
		dispatch,
		onSubmit: data => dispatch(updateSettings(data))
	}
}

const mapStateToProps = state => {

	if (isFetching([state.settings])) return { isFetching: true }
	const selector = formValueSelector('settings-status')
	const data = {
		status: selector(state, 'status')
	}

	return {
		data,
		initialValues: {
			status: state.settings.status,
		}
	}
}

SettingsStatus.propTypes = {
	dispatch: PropTypes.func,
	isFetching: PropTypes.bool
}

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
	form: 'settings-status',
})(SettingsStatus))



// WEBPACK FOOTER //
// ./src/routes/Settings/containers/SettingsStatus.js